import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postRegister = data => api.create(url.POST_REGISTER, data);

  
// Login Method
export const postLogin = data => api.create(url.POST_LOGIN, !data.refreshToken ? data : {}, { headers: { 'refreshToken': data.refreshToken } });

// postForgetPwd
export const postFakeForgetPwd = data => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// postResetPassword
export const postResetPassword = data => api.create(url.POST_RESET_PASSWORD, data);

// Edit profile
export const postJwtProfile = data => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
            case 401:
              message = "Invalid credentials";
              break;
              default:
                message = err[1];
                break;
              }
            }
            throw message;
          });
        };

        //common

export const getTableColumnNames = (columns) => api.create(url.GET_LOCALIZATION_TABLE_COLUMN_NAMES, columns);
// Login Method
export const postJwtLogin = data => api.create(url.POST_FAKE_JWT_LOGIN, data);
export const postForgotpwd = data => api.create(url.POST_FORGOTPWD, data);

// postForgetPwd
export const postJwtForgetPwd = data => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => api.create(url.SOCIAL_LOGIN, data);

// Common
export const getTranslation = (translation) => api.create(url.GET_TRANSLATION, translation)

// localization
export const getScreens = () => api.get(url.GET_SCREENS);
export const getLocalization = (localization) => api.create(url.GET_LOCALIZATION, localization);
export const addLocalization = (localization) => api.create(url.POST_LOCALIZATION, localization);
export const updateLocalization = (localization) => api.update(url.UPDATE_LOCALIZATION, localization);
export const deleteLocalization = (localization) => api.create(url.DELETE_LOCALIZATION, localization);
export const UpdateColumnPreference = (ColumnPreference) => api.put(url.UPDATE_COLUMN_PREFRENCE, ColumnPreference);
export const addScreens = (screen) => api.create(url.POST_SCREENS, screen);
export const updateScreens = (screen) => api.update(url.UPDATE_SCREENS, screen);
export const deleteScreens = (screen) => api.create(url.DELETE_SCREENS, screen);

// Logs
export const getLogs = () => api.get(url.GET_LOGS);

// Country 
export const getAllCountry = (Country) => api.get(url.GET_COUNTRY_ALL, Country);
export const updateCountryAPI = (Country) => api.put(url.UPDATE_COUNTRY, Country); 
export const activeDeactiveCountry = (Country) => api.create(url.GET_ACTIVE_DEACTIVE_COUNTRY, Country);

// Topics
export const GetAllTopics = (topics) => api.create(url.GET_TOPICS_ALL, topics);
export const addTopicsAPI = (topics) => api.create(url.ADD_TOPICS, topics);
export const updateTopicsAPI = (topics) => api.put(url.UPDATE_TOPICS, topics);
export const deleteTopicsAPI = (topics) => api.put(url.DELETE_TOPICS, topics);
export const activeDeactiveTopics = topicData => api.create(url.GET_ACTIVE_DEACTIVE_TOPICS, topicData);

// Sub Topics
export const GetAllSubTopics = (topics) => api.create(url.GET_SUB_TOPICS_ALL, topics);
export const addSubTopicsAPI = (topics) => api.create(url.ADD_SUB_TOPICS, topics);
export const updateSubTopicsAPI = (topics) => api.put(url.UPDATE_SUB_TOPICS, topics);
export const deleteSubTopicsAPI = (topics) => api.put(url.DELETE_SUB_TOPICS, topics);
export const activeDeactiveSubTopics = topicData => api.create(url.GET_ACTIVE_DEACTIVE_SUB_TOPICS, topicData);




// Roles
export const getAllRolesAPI = (role) => api.create(url.GET_All_ROLES, role);
export const getRolesAPI = (role) => api.put(url.GET_ROLES, role);
export const addRoleAPI = (role) => api.create(url.POST_ROLE, role);
export const updateRoleAPI = (role) => api.create(url.UPDATE_ROLE, role);
export const deleteRoleAPI = (role) => api.create(url.DELETE_ROLE, role);
export const activeDeactiveRoleAPI = (role) => api.create(url.ACTIVE_ROLE, role);
export const getAllPagesAPI = (role) => api.create(url.GET_All_PAGES, role);
export const updatePagePermissionAPI = (page) => api.put(url.UPDATE_PAGE_PERMISSION, page);
export const getUserModuleAPI = () => api.get(url.GET_USER_MODULE);

// Category
export const getAllCategoryAPI = (category) => api.create(url.GET_All_CATEGORIES, category);
export const getDocumentsTypeAPI = () => api.get(url.GET_DOCUMENTS_TYPE);
export const getAllParentCategoryAPI = (category) => api.create(url.GET_All_PARENT_CATEGORIES, category);
export const addCategoryAPI = (category) => api.create(url.POST_CATEGORY, category);
export const updateCategoryAPI = (category) => api.create(url.UPDATE_CATEGORY, category);
export const activeDeactiveCategoryAPI = (category) => api.create(url.ACTIVE_CATEGORY, category);
export const deleteCategoryAPI = (category) => api.create(url.DELETE_CATEGORY, category);

// Tag
export const getAllTagsAPI = () => api.get(url.GET_All_TAGS);
export const addTagAPI = (tag) => api.create(url.ADD_TAG, tag);

//Users
export const GetUsers = user => api.create(url.GET_USERS, user);
export const GetBranches = () => api.get(url.GET_BRANCHES);
export const GetGenders = () => api.get(url.GET_GENDERS);
export const GetCountry = () => api.get(url.GET_COUNTRY);
export const GetUserById = user => api.create(url.GET_USER_BY_ID, user);
export const UpdateProfile = user => api.create(url.UPDATE_USER_PROFILE, user);
export const addUser = user => api.create(url.ADD_USER, user);
export const checkUserExistenceAPI = user => api.create(url.CHECK_USER_EXISTENCE, user);
export const updateUserAPI = user => api.create(url.UPDATE_USER, user);
export const updateUserRoleAPI = user => api.create(url.UpdateUserRole, user);
export const ToggleStatusAPI = user => api.create(url.TOGGLE_USER, user);
export const DeleteUserAPI = user => api.create(url.DELETE_USER, user);

// AI Chat 
export const AddAIResponseApi = user => api.create(url.ADD_AI_RESPONSE, user, {
  timeout: 120000,  // 2-minute timeout for AI
});
export const getChatSessionHistoryApi = (params) => api.create(url.GET_CHAT_SESSION_HISTORY,params);
export const getChatHistoryApi = (params) => api.create(url.GET_CHAT_HISTORY, params);
export const likeDislikeMessageApi = (params) => api.create(url.LIKE_DISLIKE_MESSAGE, params);
export const editChatSessionTitleApi = (params) => api.create(url.EDIT_CHAT_SESSION_TITLE, params);
export const deleteChatSessionApi = (params) => api.create(url.DELETE_CHAT_SESSION, params);

// AI Document Metadata
export const getDocumentAPI = (data) => api.create(url.GET_DOCUMENTS,data)
export const addDocumentMetadataAPI = (metadata) => api.create(url.ADD_DOCUMENT_METADATA, metadata)
export const addCoreDocumentMetadataAPI = (metadata) => api.create(url.ADD_CORE_DOCUMENT_METADATA, metadata)
export const addDocumentDetails = (metadata) => api.create(url.UPLOAD_DOC_DETAILS, metadata)
export const updateDocumentDetails = (data) => api.create(url.UPDATE_DOCUMENT, data)
export const updateDocumentJsonURL = (data) => api.create(url.UPDATE_DOCUMENT_JSON_URL, data)
export const saveDocumentDetails = (data) => api.create(url.SAVE_DOC_DETAILS, data)
export const retryDocumentAPI = (data) => api.create(url.RETRY_DOCUMENT, data)
export const removeDocuments = (data) => api.create(url.REMOVE_DOCUMENTS, data)
export const reviewedDocument = (data) => api.create(url.REVIEWED_DOCUMENT, data)
export const getSubCategoryAPI = (data) => api.create(url.GET_All_SUB_CATEGORIES, data);
export const getChunkData = (data) => api.create(url.GET_CHUNK_DATA, data);

// Cases
export const getCasesAPI = (data) => api.create(url.GET_CASES, data);
export const addCaseDetails = (metadata) => api.create(url.ADD_CASE, metadata);
export const updateCaseDetails = (data) => api.create(url.UPDATE_CASE, data);
export const updateCaseJsonAPI = (data) => api.create(url.UPDATE_CASE_JSON_URL, data);
export const removeCases = (data) => api.create(url.REMOVE_CASES, data);
export const reviewedCase = (data) => api.create(url.REVIEWED_CASE, data);
export const saveCaseDetails = (data) => api.create(url.SAVE_CASE_DETAILS, data);
export const getCaseTypesAPI = (data) => api.create(url.GET_CASE_TYPES, data);
export const getCaseChunksAPI = (data) => api.create(url.GET_CASE_CHUNKS, data);

// AI Prompt
export const getAllPromptsAPI = () => api.get(url.GET_All_PROMPTS);
export const saveOrUpdatePromptAPI = (prompt) => api.create(url.SAVE_OR_UPDATE_PROMPT, prompt);

// Human Category 
export const getHumanCategories = () => api.get(url.GET_HUMAN_CATEGORIES);
export const addHumanCategories = (category) => api.create(url.ADD_HUMAN_CATEGORIES, category);
export const updateHumanCategories = (category) => api.create(url.UPDATE_HUMAN_CATEGORIES, category);
export const deleteHumanCategories = (category) => api.create(url.DELETE_HUMAN_CATEGORIES, category);
export const activateDeactivateHumanCategories = (category) => api.create(url.ACTIVATE_DEACTIVATE_HUMAN_CATEGORIES, category);

// Chat Report
export const getChatReport = (data) => api.create(url.GET_CHAT_REPORT, data);
export const getHumanCategoriesAll = (data) => api.create(url.GET_HUMAN_CATEGORIES, data);
export const getClientUsers = (data) => api.create(url.GET_CLIENT_USERS, data);
export const getHumanServiceChats = (data) => api.create(url.GET_HUMAN_SERVICE_CHATS, data);

// AI Chat Report
export const getAIChatReport = (data) => api.create(url.GET_AI_CHAT_REPORT, data);
export const getAIChat = (data) => api.create(url.GET_AI_CHATS, data);
export const updateChatFeedbackStatusApi = (data) => api.create(url.UPDATE_CHAT_FEEDBACK_STATUS, data);
export const deleteAIChatReportApi = (data) => api.create(url.DELETE_AI_CHAT_REPORT, data);

// User Reported Issue
export const getUserReportedIssues = (data) => api.create(url.GET_USER_REPORTED_ISSUES, data);
export const getUserReportedChats = (data) => api.create(url.GET_USER_REPORTED_ISSUES_CHATS, data);
export const updateUserReportedIssueStatus = (data) => api.create(url.UPDATE_USER_REPORTED_ISSUE_STATUS, data);
export const deleteUserReportedIssues = (data) => api.create(url.DELETE_USER_REPORTED_ISSUES, data);


// get Events
export const getEvents = () => api.get(url.GET_EVENTS);

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = event => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => api.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event => api.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = roomId => api.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = message => api.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = message => api.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = forId => api.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = product => api.delete(url.DELETE_PRODUCT + '/' + product);

// add Products
export const addNewProduct = product => api.create(url.ADD_NEW_PRODUCT, product);

// update Products
export const updateProduct = product => api.update(url.UPDATE_PRODUCT + '/' + product._id, product);

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = order => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = order => api.update(url.UPDATE_ORDER + '/' + order._id, order);

// delete Order
export const deleteOrder = order => api.delete(url.DELETE_ORDER + '/' + order);

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = customer => api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = customer => api.update(url.UPDATE_CUSTOMER + '/' + customer._id, customer);

// delete Customers
export const deleteCustomer = customer => api.delete(url.DELETE_CUSTOMER + '/' + customer);

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = task => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = task => api.update(url.UPDATE_TASK + '/' + task._id, task);

// delete Task
export const deleteTask = task => api.delete(url.DELETE_TASK + '/' + task);

// Kanban Board
export const getTasks = () => api.get(url.GET_TASKS);
export const addNewTasks = (card) => api.create(url.ADD_TASKS, card)
export const updateTasks = (card) => api.put(url.UPDATE_TASKS, card)
export const deleteTasks = (card) => api.delete(url.DELETE_TASKS, { headers: {card} })

// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = contact => api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = contact => api.update(url.UPDATE_CONTACT + '/' + contact._id, contact);

// delete Contact
export const deleteContact = contact => api.delete(url.DELETE_CONTACT + '/' + contact);

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = company => api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = company => api.update(url.UPDATE_COMPANIES + '/' + company._id, company);

// delete Companies
export const deleteCompanies = company => api.delete(url.DELETE_COMPANIES + '/' + company);

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = lead => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = lead => api.update(url.UPDATE_LEAD + '/' + lead._id, lead);

// delete Lead
export const deleteLead = lead => api.delete(url.DELETE_LEAD + '/' + lead);

// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = invoice => api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = invoice => api.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = invoice => api.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = ticket => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = ticket => api.update(url.UPDATE_TICKET + '/' + ticket._id, ticket);

// delete Tickets 
export const deleteTicket = ticket => api.delete(url.DELETE_TICKET + '/' + ticket);

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => api.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => api.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => api.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => api.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => api.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => api.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => api.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => api.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => api.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => api.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => api.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => api.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => api.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => api.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => api.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => api.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => api.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => api.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => api.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => api.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => api.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => api.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => api.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => api.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => api.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => api.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => api.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);
export const getDashboardData = () => api.get(url.GET_DASHBOARD_DATA);


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => api.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => api.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => api.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => api.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => api.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => api.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => api.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => api.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => api.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => api.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => api.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => api.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => api.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => api.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => api.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => api.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => api.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => api.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => api.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => api.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project) => api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project) => api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project) => api.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = (team) => api.get(url.GET_TEAMDATA, team);
export const deleteTeamData = (team) => api.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team) => api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team) => api.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = (folder) => api.get(url.GET_FOLDERS, folder);
export const deleteFolder = (folder) => api.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder) => api.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder) => api.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = (file) => api.get(url.GET_FILES, file);
export const deleteFile = (file) => api.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file) => api.create(url.ADD_NEW_FILE, file);
export const updateFile = (file) => api.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = (todo) => api.get(url.GET_TODOS, todo);
export const deleteTodo = (todo) => api.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo) => api.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo) => api.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = (project) => api.get(url.GET_PROJECTS, project);
export const addNewProject = (project) => api.create(url.ADD_NEW_TODO_PROJECT, project);

// Job Application
export const getJobApplicationList = () => api.get(url.GET_APPLICATION_LIST);

//API Key
export const getAPIKey = () => api.get(url.GET_API_KEY);

// Common
export const getDays = () => api.get(url.GET_DAYS);
export const getQuestionTypes = (type) => api.create(url.GET_QUESTION_TYPES, type);
export const getDifficultyLevelAPI = (level) => api.create(url.GET_DIFFICULTY_LEVEL, level);
export const getUsersByRoleID = (item) => api.create(url.GET_USER_BY_ROLEID, item);

export const getCommonLabels = (commonLabel) => api.create(url.GET_COMMON_LABELS, commonLabel);
export const addCommonLabels = (commonLabel) => api.create(url.POST_COMMON_LABELS, commonLabel);
export const updateCommonLabels = (commonLabel) => api.update(url.UPDATE_COMMON_LABELS, commonLabel);
export const deleteCommonLabels = (commonLabel) => api.put(url.DELETE_COMMON_LABELS, commonLabel);
export const activateDeactivateCommonLabels = (commonLabel) => api.put(url.ACTIVATE_DEACTIVATE_COMMON_LABELS, commonLabel);

const uploadDocHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  }
}
 

export const getHeaders = (module) => api.create(url.GET_HEADERS, module);
export const uploadImages = (image) => api.create(url.UPLOAD_IMAGES, image);
export const uploadDoc = (image) => api.create(url.UPLOAD_DOC, image, uploadDocHeaders);

// Courses
export const getCourses = (course) => api.get(url.GET_COURSES, course);
export const addCourses = (course) => api.create(url.POST_COURSES, course);
export const updateCourses = (course) => api.update(url.UPDATE_COURSES, course);
export const deleteCourses = (course) => api.put(url.DELETE_COURSES, course);
export const activateDeactivateCourses = (course) => api.put(url.ACTIVATE_DEACTIVATE_COURSES, course);

// Course Modules
export const getCourseModules = (module) => api.create(url.GET_COURSE_MODULES, module);
export const addCourseModules = (module) => api.create(url.POST_COURSE_MODULES, module);
export const updateCourseModules = (module) => api.update(url.UPDATE_COURSE_MODULES, module);
export const deleteCourseModules = (module) => api.put(url.DELETE_COURSE_MODULES, module);
export const toggleCourseModule = (module) => api.put(url.TOGGLE_COURSE_MODULES, module);

// Course Sessions
export const getCourseSessions = (session) => api.create(url.GET_COURSE_SESSIONS, session);
export const addCourseSessions = (session) => api.create(url.POST_COURSE_SESSIONS, session);
export const updateCourseSessions = (session) => api.update(url.UPDATE_COURSE_SESSIONS, session);
export const deleteCourseSessions = (session) => api.put(url.DELETE_COURSE_SESSIONS, session);
export const cancelCourseSession = (session) => api.put(url.CANCEL_COURSE_SESSIONS, session);
export const addAssignmentQuestions = (session) => api.put(url.POST_ASSIGNMENT_QUESTIONS, session);
export const deleteAssignmentQuestions = (session) => api.put(url.DELETE_ASSIGNMENT_QUESTIONS, session);
export const addAdditionalAssignmentQuestions = (session) => api.put(url.POST_ADDISTIONAL_ASSIGNMENT_QUESTIONS, session);
export const deleteAdditionalAssignmentQuestions = (session) => api.put(url.DELETE_ADDISTIONAL_ASSIGNMENT_QUESTIONS, session);

// Enroll Students
export const getEnrollStudents = () => api.get(url.GET_ENROLL_STUDENTS);
export const addEnrollStudents = (enrollStudents) => api.create(url.POST_ENROLL_STUDENTS, enrollStudents);
export const updateEnrollStudents = (enrollStudents) => api.update(url.UPDATE_ENROLL_STUDENTS, enrollStudents);
export const deleteEnrollStudents = (enrollStudents) => api.put(url.DELETE_ENROLL_STUDENTS , enrollStudents);
export const updateEnrollStudentsCoursePayment = (enrollStudents) => api.put(url.UPDATE_ENROLL_STUDENTS_COURSE_PAYMENT, enrollStudents);

// Referral Reward
export const getReferralReward = () => api.get(url.GET_REFERRAL_REWARD);
export const addReferralReward = (referralReward) => api.create(url.POST_REFERRAL_REWARD, referralReward);
export const updateReferralReward = (referralReward) => api.update(url.UPDATE_REFERRAL_REWARD, referralReward);
export const deleteReferralReward = (referralReward) => api.put(url.DELETE_REFERRAL_REWARD, referralReward);
export const activateDeactivateReferralReward = (referralReward) => api.put(url.ACTIVATE_DEACTIVATE_REFERRAL_REWARD, referralReward);

// Referral Earn
export const getReferralEarn = () => api.get(url.GET_REFERRAL_EARN);
export const getReferralStatus = () => api.get(url.GET_REFERRAL_STATUS);
export const updateReferralAPI = (user) => api.update(url.UPDATE_REFERRAL , user);
// export const addReferralReward = (referralReward) => api.create(url.POST_REFERRAL_REWARD, referralReward);
// export const updateReferralReward = (referralReward) => api.update(url.UPDATE_REFERRAL_REWARD, referralReward);
// export const deleteReferralReward = (referralReward) => api.put(url.DELETE_REFERRAL_REWARD, referralReward);
// export const activateDeactivateReferralReward = (referralReward) => api.put(url.ACTIVATE_DEACTIVATE_REFERRAL_REWARD

// Question
export const getQuestions = (question) => api.create(url.GET_QUESTIONS, question);
export const addQuestions = (question) => api.create(url.POST_QUESTIONS, question);
export const updateQuestions = (question) => api.update(url.UPDATE_QUESTIONS, question);
export const deleteQuestions = (question) => api.put(url.DELETE_QUESTIONS, question);
export const activateDeactivateQuestions = (question) => api.put(url.ACTIVATE_DEACTIVATE_QUESTIONS, question);
export const questionOptions = (question) => api.put(url.QUESTION_OPTIONS, question);
export const getScore = () => api.get(url.GET_SCORE);

export const getQuestionOptions = (option) => api.create(url.GET_QUESTION_OPTIONS, option);
export const addQuestionOptions = (option) => api.create(url.POST_QUESTION_OPTIONS, option);
export const updateQuestionOptions = (option) => api.update(url.UPDATE_QUESTION_OPTIONS, option);
export const deleteQuestionOptions = (option) => api.put(url.DELETE_QUESTION_OPTIONS, option);

export const getQuestionHints = (hint) => api.create(url.GET_QUESTION_HINTS, hint);
export const addQuestionHints = (hint) => api.create(url.POST_QUESTION_HINTS, hint);
export const updateQuestionHints = (hint) => api.update(url.UPDATE_QUESTION_HINTS, hint);
export const deleteQuestionHints = (hint) => api.put(url.DELETE_QUESTION_HINTS, hint);

// Question Category
export const getQuestionCategory = () => api.get(url.GET_QUESTION_CATEGORY);
export const addQuestionCategory = (questionCategory) => api.create(url.POST_QUESTION_CATEGORY, questionCategory);
export const updateQuestionCategory = (questionCategory) => api.update(url.UPDATE_QUESTION_CATEGORY, questionCategory);
export const deleteQuestionCategory = (questionCategory) => api.put(url.DELETE_QUESTION_CATEGORY, questionCategory);
export const activateDeactivateQuestionCategory = (questionCategory) => api.put(url.ACTIVATE_DEACTIVATE_QUESTION_CATEGORY, questionCategory);

// Question Attempts
export const getAttemptScore = () => api.get(url.GET_QUESTION_ATTEMPTS);
export const addAttemptScore = (attemptScore) => api.create(url.POST_QUESTION_ATTEMPTS, attemptScore);
export const updateAttemptScore = (attemptScore) => api.update(url.UPDATE_QUESTION_ATTEMPTS, attemptScore);
export const deleteAttemptScore = (attemptScore) => api.put(url.DELETE_QUESTION_ATTEMPTS, attemptScore);
export const activateDeactivateAttemptScore = (attemptScore) => api.put(url.ACTIVATE_DEACTIVATE_QUESTION_ATTEMPTS, attemptScore);

// GPA
export const getGPA = () => api.get(url.GET_GPA);
export const addGPA = (gpa) => api.create(url.POST_GPA, gpa);
export const updateGPA= (gpa) => api.update(url.UPDATE_GPA, gpa);
export const deleteGPA = (gpa) => api.put(url.DELETE_GPA, gpa);
export const activateDeactivateGPA = (gpa) => api.put(url.ACTIVATE_DEACTIVATE_GPA, gpa);

// User Type
export const GetAllUserTypesAPI = (gpa) => api.create(url.GET_USERTYPE, gpa);
// export const addGPA = (gpa) => api.create(url.POST_GPA, gpa);
// export const updateGPA= (gpa) => api.update(url.UPDATE_GPA, gpa);
// export const deleteGPA = (gpa) => api.put(url.DELETE_GPA, gpa);
// export const activateDeactivateGPA = (gpa) => api.put(url.ACTIVATE_DEACTIVATE_GPA, gpa);

// Score
export const GetAllScoresAPI = (score) => api.create(url.GET_MANAGE_SCORE, score);
export const AddScoreAPI = (score) => api.create(url.POST_SCORE, score);
export const UpdateScoreAPI = (score) => api.create(url.UPDATE_SCORE, score);
export const DeleteScoresAPI = (scoreIds) => api.create(url.DELETE_SCORE,scoreIds); 
// export const activateDeactivateGPA = (gpa) => api.put(url.ACTIVATE_DEACTIVATE_GPA, gpa);

// Document
export const GetDocumentAPI = (score) => api.create(url.GET_DOCUMENT, score);

// Crawl
export const getCrawlAPI = () => api.get(url.GET_CRAWL);
export const addCrawlAPI = (crawl) => api.create(url.ADD_CRAWL, crawl);
export const updateCrawlAPI = (crawl) => api.create(url.UPDATE_CRAWL, crawl);
export const deleteCrawlAPI = (crawl) => api.create(url.DELETE_CRAWL, crawl);
export const activateDeactivateCrawlAPI = (crawl) => api.create(url.ACTIVATE_DEACTIVATE_CRAWL, crawl);

// News
export const getNewsAPI = () => api.get(url.GET_NEWS);
export const addNewsAPI = (news) => api.create(url.ADD_NEWS, news);
export const updateNewsAPI = (news) => api.create(url.UPDATE_NEWS, news);
export const deleteNewsAPI = (news) => api.create(url.DELETE_NEWS, news);
export const activateDeactivateNewsAPI = (news) => api.create(url.ACTIVATE_DEACTIVATE_NEWS, news);

export const getNewsDataAPI = () => api.get(url.GET_NEWS_DATA);
export const addNewsDataAPI = (newsData) => api.create(url.ADD_NEWS_DATA, newsData);
export const updateNewsDataAPI = (newsData) => api.create(url.UPDATE_NEWS_DATA, newsData);
export const deleteNewsDataAPI = (newsData) => api.create(url.DELETE_NEWS_DATA, newsData);
export const activateDeactivateNewsDataAPI = (newsData) => api.create(url.ACTIVATE_DEACTIVATE_NEWS_DATA, newsData);

// Subscriptions
export const getSubscriptionAPI = () => api.get(url.GET_SUBSCRIPTIONS);
export const addSubscriptionAPI = (subcription) => api.create(url.ADD_SUBSCRIPTIONS, subcription);
export const updateSubscriptionAPI = (subcription) => api.create(url.UPDATE_SUBSCRIPTIONS, subcription);
export const deleteSubscriptionAPI = (subcription) => api.create(url.DELETE_SUBSCRIPTIONS, subcription);
export const activateDeactivateSubscriptionAPI = (subcription) => api.create(url.ACTIVATE_DEACTIVATE_SUBSCRIPTIONS, subcription);
export const getSubscriptionTagsAPI = (subcription) => api.create(url.GET_SUBSCRIPTION_TAGS, subcription);

// User Payment 
export const getUserWithTotalPayment = (data) => api.create(url.GET_USER_WITH_TOTAL_PAYMENT, data);
export const getUserPaymentHistory = (data) => api.create(url.GET_USER_PAYMENT_HISTORY, data);
// export const updateChatFeedbackStatusApi = (data) => api.create(url.UPDATE_CHAT_FEEDBACK_STATUS, data);

// Law Report
export const getLawReport = (lawReport) => api.create(url.GET_LAW_REPORT, lawReport);
export const getLawStatus = (status) => api.create(url.GET_LAW_STATUS, status);
export const getArticleStatus = (status) => api.create(url.GET_ARTICLE_STATUS, status);
export const getInstrumentType = (status) => api.create(url.GET_INSTRUMENT_TYPE, status);
export const updateJsonStatus = (status) => api.create(url.UPDATE_JSON_STATUS, status);

// Legal Rank
export const getLegalRank = () => api.get(url.GET_LEGAL_RANK);
export const addLegalRank = (legalRank) => api.create(url.ADD_LEGAL_RANK, legalRank);
export const updateLegalRank = (legalRank) => api.create(url.UPDATE_LEGAL_RANK, legalRank);
export const deleteLegalRank = (legalRank) => api.create(url.DELETE_LEGAL_RANK, legalRank);
export const activateDeactivateLegalRank = (legalRank) => api.create(url.ACTIVATE_DEACTIVATE_LEGAL_RANK, legalRank);